import { NavLink, Outlet } from 'react-router-dom';
import { BookOpen, Code2, FileText, MessageSquare, Palette, Puzzle } from 'lucide-react';

const NAV = [
  {
    section: 'Getting Started',
    items: [
      { to: '/docs/overview', label: 'Overview', title: 'Product overview and quick start', icon: BookOpen },
    ],
  },
  {
    section: 'Integration',
    items: [
      { to: '/docs/sdk',       label: 'SDK Setup',     title: 'JavaScript SDK installation', icon: Code2         },
      { to: '/docs/theming',   label: 'Theming',       title: 'Customize guide appearance', icon: Palette       },
      { to: '/docs/api',       label: 'API Reference', title: 'REST API documentation', icon: FileText      },
      { to: '/docs/chat',      label: 'Chat SDK',      title: 'Embed AI chat in your app', icon: MessageSquare },
    ],
  },
  {
    section: 'Extension',
    items: [
      { to: '/docs/extension', label: 'Extension', title: 'Browser extension download and install', icon: Puzzle },
    ],
  },
] as const;

export function DocsLayout() {
  return (
    <div className="flex min-h-0 min-w-0 w-full max-w-full gap-8">
      {/* ── Left sidebar ────────────────────────────────────────────── */}
      <nav className="hidden md:block w-48 shrink-0 pt-0.5">
        <div className="sticky top-0 space-y-5">
          {NAV.map(({ section, items }) => (
            <div key={section}>
              <p className="mb-1.5 px-2 text-[10.5px] font-semibold uppercase tracking-wider text-fg-3/70">
                {section}
              </p>
              <ul className="space-y-0.5">
                {items.map(({ to, label, title, icon: Icon }) => (
                  <li key={to}>
                    <NavLink
                      to={to}
                      title={title}
                      className={({ isActive }) =>
                        `flex items-center gap-2.5 rounded-lg px-2.5 py-2 text-[13px] font-medium
                         transition-colors duration-100
                         ${isActive
                           ? 'bg-brand-500/10 text-brand-600'
                           : 'text-fg-3 hover:text-fg hover:bg-surface-2'}`
                      }
                    >
                      <Icon size={14} aria-hidden />
                      {label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </nav>

      {/* ── Page content ─────────────────────────────────────────────── */}
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
